const { getCookie } = require('../cookies')
const { isDirectTraffic } = require('./is-direct-traffic')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} referer
 * @param {string|null} orgReferer
 * @returns {*}
 */
function getReferer (referer, orgReferer = null) {
  let ref = referer

  if (!ref || isDirectTraffic(ref)) {
    ref = orgReferer || getCookie('OrgReferer')
    ref = ref && decodeURIComponent(ref)
  }

  if (isDirectTraffic(ref)) {
    ref = null
  }

  return ref
}

module.exports = { getReferer }
